import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import { useStyles } from '~/views/atoms/chip/styles';
export const Chip = ({ label, className }) => {
    const classes = useStyles();
    return (_jsx(Box, { className: clsx(classes.chipContainer, className), children: _jsx(Typography, { variant: "body1", children: label }) }));
};
